import groq from 'groq'

import { metadata } from '../metadata.js'

import { header } from './sections/header.js'
import { problem } from './sections/problem.js'
import { solution } from './sections/solution.js'
import { features } from './sections/features.js'
import { products } from './sections/products.js'
import { whyAum } from './sections/whyAum.js'

import { footer } from '../footer.js'

export function landing() {
	return groq`*[_type == 'page.landing'][0]{
    _type,
    "metadata": metadata{...${metadata()}},
    "footer":{...${footer()}},
    "sections": sections[] {
      _type,
      _type == 'header' => {${header}},
      _type == 'problem' => {${problem}},
      _type == 'solution' => {${solution}},
      _type == 'features' => {${features}},
      _type == 'products' => {${products}},
      _type == 'whyAum' => {${whyAum}},
     }
  }
  `
}
